module.exports = __webpack_public_path__ + "assets/images/KYD1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/KYD1.png
// module id = 1411
// module chunks = 1